import React, { useState } from "react";

function DynamicForm() {
  const [fields, setFields] = useState([{ value: "" }]);

  // Add new input field
  const addField = () => {
    setFields([...fields, { value: "" }]);
  };

  // Remove specific input field
  const removeField = (index) => {
    const newFields = fields.filter((_, i) => i !== index); // Remove field at the given index
    setFields(newFields);
  };

  // Update the value of an input field
  const handleInputChange = (index, event) => {
    const newFields = [...fields];
    newFields[index].value = event.target.value;
    setFields(newFields);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "auto", borderRadius: "8px" }}>
      <h2>Open week</h2>
      {fields.map((field, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
          <input
            type="text"
            placeholder={`Enter text ${index + 1}`}
            value={field.value}
            onChange={(e) => handleInputChange(index, e)}
            style={{ flex: 1, padding: "8px", borderRadius: "4px" }}
          />
          <button
            onClick={() => removeField(index)}
            style={{
              marginLeft: "10px",
              padding: "8px 12px",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            -
          </button>
        </div>
      ))}
      <button
        onClick={addField}
        style={{
          padding: "8px 12px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        +
      </button>
    </div>
  );
}

export default DynamicForm;
